import "./sass/style.scss";

import "./js/news-slider";
import "./js/custom";
import "./js/raining-hearts";
import "./js/prospektformular";
import "./js/tabs";
import "./js/openstreetmap-embed";
// Berlin-time open/closed for footer, cards, singles (cache-safe).
import { bindOpeningStatusAutoRefresh } from "./js/opening-hours-status";
import "./js/restaurant-archive";
// Gastgeber detail page: opening-hours pill + flyout with tabs.
import "./js/gastgeber-opening-hours";
// Detail pages: recommendation cards, swaps closed venues for open ones.
import "./js/related-content";
// Merkliste: Merken-Buttons, Header-Zähler und Rückmeldung (Liste: merkliste-bundle.js).
import "./js/favorites/toggles";

// Theme-wide tooltip chip: flips and shifts .ws-tip so it stays on screen.
import "./js/tooltip";

// Relaunch 2026 — frontpage / Buerger page behaviour.
import "./js/footer-tooltip";
import "./js/highlights-reveal";
import "./js/frontpage-news";
import "./js/filter-rail-scroll";
import "./js/buerger-news";
import "./js/highlight-swiper";
import "./js/topthemen-slider";

// import "./js/campaign";
// import "./backstretch";

// Live open/closed pills (cards, singles, footer) — see opening-hours-status.js.
bindOpeningStatusAutoRefresh();
